import React, { useState, useRef } from "react";
import ApplicationBar from "../components/ApplicationBar";
// import loader from "../assets/vv-loader2.gif";
import loader from '../assets/loader.gif'
import { RootState } from "../redux/reducer";
import { connect, ConnectedProps } from "react-redux";
import {
  logOutUser,
  setSessionTimeoutError,
  setProjectName,
} from "../redux/action";
import ErrorDialog from "../components/ErrorDialog";
import { Customers } from "./customers";
import { Typography } from "@mui/material";
import { blue } from "@mui/material/colors";

type PropsFromRedux = ConnectedProps<typeof connector>;
type DashboardRouterProps = PropsFromRedux & {};
const DashboardRouter: React.FC<DashboardRouterProps> = ({
  loading,
  logOutUser,
  sessionTimeoutError,
  setSessionTimeoutError,
  setProjectName,
  currentProjectName,
  ...rest
}) => {
  const onLogoutClick = () => {
    logOutUser();
    setSessionTimeoutError(false);
  };

  const renderCurrentCustomerUI = () => {
    const currentCustomer = Customers.filter((customer: {name: string, component: React.FC}) => {return customer.name === currentProjectName});
    if(currentCustomer && currentCustomer.length){
      const key = currentCustomer[0].name;
      const Component = currentCustomer[0].component;
      return (<Component key={key}/>);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        backgroundColor: "white",
        flexDirection: "column",
        flex: 1,
      }}
    >
      <ApplicationBar
        onLogout={onLogoutClick}
        onProjectChange={(name: string) => setProjectName(name)}
        projectName={currentProjectName}
        customers={Customers}
      />

      {renderCurrentCustomerUI()}

      {loading ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            position: "absolute",
            display: "flex",
            backgroundColor: "rgba(255,255,255,0.4)",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
         <img src={loader}  style={{height:'5rem'}}/> 
          <Typography color={blue[900]}>Loading Data...</Typography>
        </div>
      ) : null}

      <ErrorDialog open={sessionTimeoutError} onSubmit={onLogoutClick} />
    </div>
  );
};

const mapState = (state: RootState) => ({
  loading: state.app.loading,
  sessionTimeoutError: state.user.sessionTimeoutError,
  currentProjectName: state.report.currentProjectName,
});

const connector = connect(mapState, {
  logOutUser,
  setSessionTimeoutError,
  setProjectName,
});
export default connector(DashboardRouter);
